import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button, Divider, Grid } from '@mui/material';
import gelir from '../../../../../assets/gelir.png';
import loader from '../../../../../assets/loaderTerminal.svg';
import useProfile from '../../../../../hooks/useProfile';
import Pusher, { Channel } from 'pusher-js';
import pos from '../../../../../services/api/pos/pos';
import { useSnackbar } from 'notistack';

interface CustomModalProps {
  open: boolean;
  onClose: () => void;
  backClick: () => void;
  paymentList: any;
  onConfirm: () => void;
}

const KuikPaymentInvoice: React.FC<CustomModalProps> = ({
  open,
  onClose,
  paymentList,
  backClick,
  onConfirm,
}) => {
  const { meProfile } = useProfile();
  let pusher: Pusher | null = null;
  let channel: Channel | null = null;
  let orderChannel: Channel | null = null;
  const [transaction, setTransaction] = React.useState<any>(null);
  const { enqueueSnackbar } = useSnackbar();
  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        setShowButtons(true);
      }, 25000); // 20 seconds

      return () => clearTimeout(timer);
    }
  }, [open]);

  useEffect(() => {
    console.log('meProfile:', meProfile);
    console.log('meProfile?.activeBranch:', meProfile?.activeBranch);
    console.log('meProfile?.activeBranch?.id:', meProfile?.activeBranch?.id);
    if (meProfile?.activeBranch?.id) {
      const appKey = process.env.REACT_APP_PUSHER_APP_KEY || '';

      // @ts-ignore
      pusher = new Pusher(appKey, {
        cluster: 'eu',
      });

      orderChannel = pusher.subscribe(`branch.${meProfile?.activeBranch?.id}`);
      console.log(
        'Subscribed to channel:',
        `branch.${meProfile?.activeBranch?.id}`,
      );

      orderChannel.bind('payment.gateway.transaction.updated', r => {
        console.log('Pusher event received:', r);
        setTransaction(r.status);
      });

      orderChannel.bind('pusher:subscription_succeeded', () => {
        console.log('Pusher subscription succeeded');
      });

      orderChannel.bind('pusher:subscription_error', status => {
        console.error('Pusher subscription error:', status);
      });

      return () => {
        if (orderChannel) {
          // @ts-ignore
          orderChannel.unsubscribe(`branch.${meProfile?.activeBranch?.id}`);
          console.log(
            'Unsubscribed from channel:',
            `branch.${meProfile?.activeBranch?.id}`,
          );
        }
        if (pusher) {
          pusher.disconnect();
        }
      };
    }
  }, [meProfile?.activeBranch?.id]);

  useEffect(() => {
    if (meProfile?.activeBranch?.id) {
      const appKey = process.env.REACT_APP_PUSHER_APP_KEY || '';

      // @ts-ignore
      pusher = new Pusher(appKey, {
        cluster: 'eu',
      });

      orderChannel = pusher.subscribe(`branch.${meProfile?.activeBranch?.id}`);
      console.log(
        'Subscribed to channel:',
        `branch.${meProfile?.activeBranch?.id}`,
      );

      orderChannel.bind('payment.gateway.transaction.updated', r => {
        console.log('Pusher event received:', r);
        setTransaction(r.status);
      });

      orderChannel.bind('pusher:subscription_succeeded', () => {
        console.log('Pusher subscription succeeded');
      });

      orderChannel.bind('pusher:subscription_error', status => {
        console.error('Pusher subscription error:', status);
      });

      return () => {
        if (orderChannel) {
          // @ts-ignore
          orderChannel.unsubscribe(`branch.${meProfile?.activeBranch?.id}`);
          console.log(
            'Unsubscribed from channel:',
            `branch.${meProfile?.activeBranch?.id}`,
          );
        }
        if (pusher) {
          pusher.disconnect();
        }
      };
    }
  }, []);

  const check = async () => {
    try {
      await pos.checkPaymentStatus();
      enqueueSnackbar(' İşleminiz başarılı', { variant: 'success' });
    } catch (error) {
      console.error('Error pairing terminal:', error);
      enqueueSnackbar('Failed to pair terminal', { variant: 'error' });
    }
  };
  const manuelApprove = async () => {
    try {
      await pos.manuelPayment();
      enqueueSnackbar('Manuel ödeme işleminiz başarılı', {
        variant: 'success',
      });
    } catch (error) {
      console.error('Error pairing terminal:', error);
      enqueueSnackbar('Failed to pair terminal', { variant: 'error' });
    }
  };
  const cancelPayment = async () => {
    try {
      await pos.cancelPayment();
      onClose();
      enqueueSnackbar('İptal işleminiz başarılı', { variant: 'success' });
    } catch (error) {
      console.error('Error pairing terminal:', error);
      enqueueSnackbar('Failed to pair terminal', { variant: 'error' });
    }
  };

  useEffect(() => {
    if (transaction) {
      const timer = setTimeout(() => {
        backClick();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [transaction]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          p: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 'bold',
            mb: 2,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <img
            src={gelir}
            alt="Logo"
            style={{ width: 30, height: 30, marginRight: 8 }}
          />
          E-Belge Oluşturma
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ minHeight: 200, textAlign: 'center' }}
        >
          <Grid item xs={12}>
            {transaction === null ? (
              <div>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Satış Kuik POS’a Aktarıldı.
                </Typography>
                <img
                  src={loader}
                  alt="Logo"
                  style={{ width: 100, height: 100 }}
                />
              </div>
            ) : transaction === true ? (
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Satış başarıyla gerçekleşti.
              </Typography>
            ) : (
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                İşleminiz başarısız
              </Typography>
            )}
          </Grid>
        </Grid>
        <Divider sx={{ mt: 2, mb: 2 }} />
        <Box display="flex" justifyContent="space-between">
          {transaction !== true && (
            <Button variant="contained" color="error" onClick={cancelPayment}>
              Vazgeç
            </Button>
          )}
          {showButtons ||
            (transaction === false && (
              <div>
                <Button
                  variant="contained"
                  color="success"
                  sx={{ mr: 2 }}
                  onClick={manuelApprove}
                >
                  Tahsil Edildi
                </Button>
                <Button variant="contained" color="success" onClick={check}>
                  Ödeme Kontrolü
                </Button>
              </div>
            ))}
        </Box>
      </Box>
    </Modal>
  );
};

export default KuikPaymentInvoice;
